var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const DIVIDER = "/";
export class StorageAdapterLS {
    constructor(options) {
        this.options = {
            scope: "opendash",
        };
        if (options) {
            this.options = Object.assign({}, this.options, options);
        }
    }
    onContext(context) {
        this.context = context;
        this.init();
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.clear();
            for (const key in localStorage) {
                if (key.startsWith(this.options.scope + DIVIDER)) {
                    this.context.set(key.replace(this.options.scope + DIVIDER, ""), window.localStorage.getItem(key));
                }
            }
            this.context.setLoading(false);
        });
    }
    set(key, value) {
        return __awaiter(this, void 0, void 0, function* () {
            window.localStorage.setItem(this.options.scope + DIVIDER + key, value);
            this.context.set(key, value);
        });
    }
    delete(key) {
        return __awaiter(this, void 0, void 0, function* () {
            window.localStorage.removeItem(this.options.scope + DIVIDER + key);
            this.context.delete(key);
        });
    }
    clear() {
        return __awaiter(this, void 0, void 0, function* () {
            window.localStorage.clear();
            this.context.clear();
        });
    }
}
//# sourceMappingURL=StorageAdapterLS.js.map